var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-switch',{attrs:{"color":"success","value":_vm.value,"label":_vm.label},model:{value:(_vm.internal),callback:function ($$v) {_vm.internal=$$v},expression:"internal"}})}
var staticRenderFns = []

export { render, staticRenderFns }